<template>
  <div>
    <div class="text-right">
      <template>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              medium
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="New()"
              >mdi-plus</v-icon
            >
          </template>
          <span>New Card</span></v-tooltip
        >
        <v-icon medium color="error" @click="Reload()" class="pl-2"
          >mdi-refresh</v-icon
        >

        <v-data-table
          :headers="headers"
          :items="desserts"
          sort-by="calories"
          class="elevation-1"
          :search="search"
          :loading="loadingstatus"
          loading-text="Loading... Please wait"
        >
          <template v-slot:top>
            <v-text-field
              v-model="search"
              label="Search"
              single-line
              hide-details
              class="ml-4 mr-4 mb-5"
            ></v-text-field>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)"
              >mdi-pencil</v-icon
            >
            <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
          </template>
          <template v-slot:no-data>
            <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            No Record(s)
          </template>
        </v-data-table>
      </template>

      <v-navigation-drawer v-model="sheet" right persistent temporary  fixed style="width: 100%; max-width:400px; margin: auto">
        <v-sheet class="text-center" min-height="200px">
          <div class="py-3 text-left">
            <v-card
              flat
              max-width="500px"
              style="width: 100%; margin: auto"
              class="pa-3"
            >
              <v-toolbar color="transparent" flat>
                 {{ EntryMode }}
                <v-spacer></v-spacer>

                <v-btn icon light>
                  <v-icon color="red darken-2" @click="sheet = !sheet"
                    >mdi-close</v-icon
                  >
                </v-btn>
              </v-toolbar>
              <v-divider></v-divider>
              <v-form ref="form" v-model="valid">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="12">
                    <v-text-field
                    v-model="postBody.sub_category_name"
                      label="Name*"
                      outlined
                      required
                      :rules="Vstatus_name"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>

              <v-card-actions class="justify-center">
                <v-btn color="success" :disabled="!valid" raised dark large @click="save">
                  SAVE
                </v-btn>
              </v-card-actions>

              <!-- <v-footer class="mt-6 justify-center">
          
        </v-footer> -->
        </v-form>
            </v-card>
          </div>
        </v-sheet>
      </v-navigation-drawer>
    </div>

     <v-snackbar v-model="snackbar" shaped top :color="snackbarcolor">
      {{ snackbartext }}
      <v-btn color="indigo" text @click="snackbar = false" >Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
//import { mapMutations } from 'vuex'
import axios from "axios";
export default {
  data() {
    return {
      snackbar: false,
    snackbartext: "",
    snackbarcolor: "primary",
      EntryMode: "",
      valid: false,
      mode: "NEW",
      newmode: true,
      sheet: false,
      search: "",
      loadingstatus: false,
     status_id:"",
      postBody: {
      sub_category_name:"",
     
    },
      headers: [
        // {
        //   text: "cid",
        //   align: "left",
        //   sortable: false,
        //   value: "mc_id",
          
        // },
        { text: "Category", value: "subcategory_name",align: 'left' },
        //  { text: "Actions", value: "actions", sortable: false,align: 'right' },
      ],
      desserts: [],
       Vstatus_name: [
      v => !!v || "Status is required"
     // v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],
    };
  },
  mounted() {
    this.$store.commit("setPageTitle", "Media Role Master");
    this.Reload();
  },
  methods: {
     showSnackbar: function (scolor, stext) {
      this.snackbar = true;
      this.snackbartext = stext;
      this.snackbarcolor = scolor;
    },
    Reload: function () {
      this.loadingstatus = true;
      axios
        .get(this.$apiPath + "Media/mediasubcategorylist", {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.desserts = res.data.result;
          this.loadingstatus = false;
        })
        .catch()
        .finally();
    },
    New(){
      this.EntryMode = "New Category";
      this.postBody.sub_category_name="";
      this.sheet = true;
    },
     editItem(item) {
      this.EntryMode = "Edit Category";
      this.postBody.status_name=item.status_name;
      this.status_id=item.status_id;
     // this.postBody.Vendor_Name = item.Vendor_Name; //Object.assign({}, item)
     

     // this.postBodyUpdate.Vendor_Id = parseInt(item.Vendor_Id);

      this.sheet = true;
    },

     deleteItem(item) {
      //alert(item.Vendor_Id);
      const index = this.desserts.indexOf(item);
      if (confirm("Are you sure you want to delete this Status?")) {
        axios
          .delete(this.$apiPath + "Status/" + item.status_id, {
            headers: { Appkey: this.$aKey },
          })
          .then(() => {
           // this.desserts = res.data.result;
            this.showSnackbar("Success", "Status Deleted  !");
           this.Reload();
          })
          .catch()
          .finally();
      }
       this.desserts.splice(index, 1);
       this.Reload();
    },

    close() {
      this.sheet = false;
      this.Reload();
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
     save() {
    this.$refs.form.validate();
    console.log(this.postBody);
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
        if (this.EntryMode == "New Category") {
          axios
            .post(this.$apiPath + "Media/mediasubcategory", this.postBody, {
              headers: { Appkey: this.$aKey },
            })
            .then((res) => {
              if (res.data.status == "Success") {
                this.showSnackbar("Success", "Category Created!");
                this.Reload();
              }
            })
            .catch()
            .finally();
        } else {
         // this.postBodyUpdate.Vendor_Name = this.postBody.Vendor_Name; //Object.assign({}, item)
         console.log(this.postBody);
          axios
          
            .put(this.$apiPath + "Status/" + this.status_id, this.postBody, {
              headers: { Appkey: this.$aKey },
            })
            .then((res) => {
              if (res.data.status == "Success") {
               // console.log(this.postBodyUpdate);
                this.showSnackbar("Success", "Status Updated!");
                this.Reload();
              }
            })
            .catch()
            .finally();
        }
      }
      this.close();

     },
  },
};
</script>

<style>
</style>